import { render } from "./5.VipJet.vue?vue&type=template&id=48ffc82f&scoped=true"
import script from "./5.VipJet.vue?vue&type=script&lang=js"
export * from "./5.VipJet.vue?vue&type=script&lang=js"

import "./5.VipJet.vue?vue&type=style&index=0&id=48ffc82f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ffc82f"]])

export default __exports__